export const DEFAULT_MOBILE_HEADER = "default";

export const MOBILE_HEADER_OPTIONS = [
  {
    id: "default",
    label: "Default header",
    hint: "Current header. Used when none is selected.",
  },
  {
    id: "header2",
    label: "Alternate header",
    hint: "New mobile header layout.",
  },
] as const;

export const MOBILE_HEADER_IDS = MOBILE_HEADER_OPTIONS.map((item) => item.id);

export const normalizeMobileHeaderId = (value?: string | null) => {
  const id = String(value || "").trim();
  if (!id || id === "default") return DEFAULT_MOBILE_HEADER;
  if (id === "header2" || id === "alternate" || id === "new" || id === "mobile-2") {
    return "header2";
  }
  return DEFAULT_MOBILE_HEADER;
};
